<template>
  <div class='main fc ac'>
    <img style='width:105px;height:105px;margin-top: 147px;' src='../../assets/index/笑脸.png' alt />

    <div class='fr jc ac mt30' style='color: #e90001;font-weight: bold;'>您的信息已登记成功!</div>

    <div class='fr jc ac' style='color: #e90001;font-weight: bold;'>我们将于十个工作日联系你</div>

    <div>
      <van-button @click='toHome' class='mt30' style='width: 126px;' round type='danger'>返回首页</van-button>
    </div>
  </div>
</template> 
<script>
export default {
  methods:{
    toHome(){
      this.$router.push({
        path:"/cornealDonation"
      })
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  padding: 30px;
  width: 100vw;
  height: 100vh;
  background-image: url("./../../assets/index/bg.png");
  background-size: cover;
}
</style>